'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/share.ejs');
var { isMobile } = require('../util/is-mobile');

module.exports = Backbone.View.extend({
    className: 'view-share',
    events: {
        'click a': 'share'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        options = options || {};
        this.model = options.model;
        this.isThanks = options.isThanks;
        this.shareUrl = options.shareUrl;
    },
    /**
     *
     */
    render: function () {
        var model = this.model.toJSON();
        this.$el.html(template(model));

        if (isMobile.any()) {
          this.$('.whatsapp').css('display','inline-block');
        }

        return this;
    },
    /**
     * [share description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    share: function(e) {
        var platform = e.currentTarget.className;

        var omParams = {
          name: (this.isThanks ? 'thanks ' : 'footer ') + platform + ' share button',
          section: this.isThanks ? 'thanks-modal' : '', 
          url: window.location.href
        };
        var gaParams = {
          eventCategory: 'Button Click',
          eventAction: 'Click Share Button : ' + ((this.isThanks) ? 'Thanks' : 'Footer') + ' : ' + platform
        };

        PubSub.trigger('linkClick', omParams, gaParams);

        if(platform === 'facebook') {
          e.preventDefault();
          var shareUrl = this.model.get('share').facebook.redirect_uri || this.shareUrl;

          this.shareToFacebook(shareUrl);
        }
    },
    shareToFacebook: function(url) {
      window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${url}`,
          'popup',
          'width=600, height=400, scrollbars=no'
      );
    },
    /**
     *
     */
    remove: function() {
        this.stopListening();
        this.off();
        this.model = null;
        return Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/share.js